'use strict';


var MapperRt = 0;

var Internal = 0;

var true_ = true;

var false_ = false;

var Null = 0;

var Undefined = 0;

var Nullable = 0;

var Null_undefined = 0;

var Exn = 0;

var $$Array = 0;

var $$String = 0;

var $$Boolean = 0;

var Re = 0;

var Promise = 0;

var $$Date = 0;

var Dict = 0;

var Global = 0;

var Json = 0;

var $$Math = 0;

var Obj = 0;

var Typed_array = 0;

var Types = 0;

var Float = 0;

var Int = 0;

var Option = 0;

var Result = 0;

var List = 0;

var Vector = 0;

var Console = 0;

exports.MapperRt = MapperRt;
exports.Internal = Internal;
exports.true_ = true_;
exports.false_ = false_;
exports.Null = Null;
exports.Undefined = Undefined;
exports.Nullable = Nullable;
exports.Null_undefined = Null_undefined;
exports.Exn = Exn;
exports.$$Array = $$Array;
exports.$$String = $$String;
exports.$$Boolean = $$Boolean;
exports.Re = Re;
exports.Promise = Promise;
exports.$$Date = $$Date;
exports.Dict = Dict;
exports.Global = Global;
exports.Json = Json;
exports.$$Math = $$Math;
exports.Obj = Obj;
exports.Typed_array = Typed_array;
exports.Types = Types;
exports.Float = Float;
exports.Int = Int;
exports.Option = Option;
exports.Result = Result;
exports.List = List;
exports.Vector = Vector;
exports.Console = Console;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./~/bs-platform/lib/js/js.js
// module id = 327
// module chunks = 168707334958949